$(document).ready(function(){
      $('.offer_first_drawer .inner_content').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots:false,
      arrows:false,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    }); 
     $('.customer_main').slick({
      slidesToShow:4,
      dots:true,
      arrows:false,
      appendDots: '.customer_results_dots',
      responsive:[
        {
          breakpoint:992,
          settings: {
            slidesToShow:2,
          }
        }
      ]
    });

     $('.service_main').slick({
      slidesToShow:3,
      dots:true,
      arrows:false,
      centerMode:false,
     
      responsive:[
        {
          breakpoint:1200,
          settings: {
            slidesToShow:3,
          }
        },
        {
          breakpoint:992,
          settings: {
            slidesToShow:2,
            centerMode:true,
          }
        },
        {
          breakpoint:768,
          settings: {
            slidesToShow:1,
            centerMode:true,
          }
        }
      ]
    });
  function upsellSlider(){
    $('.upsellBundle_content_wrapper').slick({
      slidesToShow: 1,
      dots: false,
      arrows: false,
      asNavFor: '.upsellBundle_images_wrapper' 
    });
    $('.upsellBundle_images_wrapper').slick({
      slidesToShow: 1,
      dots: true,
      arrows: true,
      asNavFor: '.upsellBundle_content_wrapper',
      prevArrow:'<div class="slick-arrow slick-prev"><svg fill="#000000" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve"><path id="XMLID_92_" d="M111.213,165.004L250.607,25.607c5.858-5.858,5.858-15.355,0-21.213c-5.858-5.858-15.355-5.858-21.213,0.001l-150,150.004C76.58,157.211,75,161.026,75,165.004c0,3.979,1.581,7.794,4.394,10.607l150,149.996C232.322,328.536,236.161,330,240,330s7.678-1.464,10.607-4.394c5.858-5.858,5.858-15.355,0-21.213L111.213,165.004z"/></svg></div>',
      nextArrow:'<div class="slick-arrow slick-next"><svg fill="#000000" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve"><path id="XMLID_92_" d="M111.213,165.004L250.607,25.607c5.858-5.858,5.858-15.355,0-21.213c-5.858-5.858-15.355-5.858-21.213,0.001l-150,150.004C76.58,157.211,75,161.026,75,165.004c0,3.979,1.581,7.794,4.394,10.607l150,149.996C232.322,328.536,236.161,330,240,330s7.678-1.464,10.607-4.394c5.858-5.858,5.858-15.355,0-21.213L111.213,165.004z"/></svg></div>'
    });
  }
 
  $(".similar-products .upsell_products .upsell_products--content").on("click",function() {
    $('.upsellBundle_popup').show();
    $('.upsellBundle_popup_overlay').addClass('active').parents('body').addClass('popup_active'); 
    upsellSlider();

    // Trigger slick slider index
    var slideIndex = $(this).parents(".upsell_products").data("index");
    console.log(slideIndex, "slick slider index================================================");
    $('.upsellBundle_content_wrapper').slick('slickGoTo', parseInt(slideIndex - 1), false);
  });

  $('.popup_close').click(function(){
    $('.upsellBundle_popup').hide();
    $('.upsellBundle_popup_overlay').removeClass('active').parents('body').removeClass('popup_active');
    
    // To destroy (unslick) the slider
    $('.upsellBundle_content_wrapper').slick('unslick');
    $('.upsellBundle_images_wrapper').slick('unslick');
  });
  
  $('.upsellBundle_popup_overlay').click(function(){
    $('.upsellBundle_popup').hide();
    $(this).removeClass('active').parents('body').removeClass('popup_active');
    
    // To destroy (unslick) the slider
    $('.upsellBundle_content_wrapper').slick('unslick');
    $('.upsellBundle_images_wrapper').slick('unslick');
  });

  var i = 0;
  if (window.matchMedia('(min-width: 544px)').matches) {
    $('.similar-products.desktop_product_view .Add-on').each(function(){
      if($('.Add-on').is(':checked')) {
        $(".product_form .shopify-product-form").append("<input type='hidden' name='items["+i+"][id]' value='"+this.value+"'>");
        i++;
      }
      var onLoadItemCheckedLength = $('.Add-on:checked').length;
    });
  } else {
    $('.similar-products.mobile_product_view .Add-on').each(function(){
      if($('.Add-on').is(':checked')) {
        $(".product_form .shopify-product-form").append("<input type='hidden' name='items["+i+"][id]' value='"+this.value+"'>");
        i++;
      }
      var onLoadItemCheckedLength = $('.Add-on:checked').length;
    });
  }

  if (window.matchMedia('(min-width: 544px)').matches) {
    $('.similar-products.desktop_product_view .Add-on').change(function() {
      if(this.checked) {
        $(".product_form .shopify-product-form").append("<input type='hidden' name='items["+i+"][id]' value='"+this.value+"'>");
        i++;
      } else{
        $(".product_form .shopify-product-form").find("[value='" + this.value + "']").remove();
        i--;
      }
      var itemCheckedLength = $('.Add-on:checked').length;
      // }
    });
  } else {
    $('.similar-products.mobile_product_view .Add-on').change(function() {
      if(this.checked) {
        $(".product_form .shopify-product-form").append("<input type='hidden' name='items["+i+"][id]' value='"+this.value+"'>");
        i++;
      } else{
        $(".product_form .shopify-product-form").find("[value='" + this.value + "']").remove();
        i--;
      }
      var itemCheckedLength = $('.Add-on:checked').length;
      // }
    });
  }

  $(".section--full-image-with_text .global-button").click(function(){
    if($(".product__details .add_to_cart").length) {
      $(".product__details .add_to_cart").click();
    }
  });

  $(document).on("click", ".product_view", function(){
    $(".thumbnail-slide").each(function() {
        console.log("click triggered ==============================");
        
        // Find the selected and second slides within the current thumbnail-slide
        var selectedFlickitySlide = $(".thumbnail-slide").find('.image-element__wrap.is-selected');
        var secondFlickitySlide = $(".thumbnail-slide").find('.image-element__wrap:nth-child(2)');
        
        // Log the selected and second slides for debugging
        console.log("Selected Slide:", selectedFlickitySlide);
        console.log("Second Slide:", secondFlickitySlide);
        
        // Trigger changes to the selected slide
        selectedFlickitySlide.removeClass("is-selected").attr("aria-selected", "false");
        secondFlickitySlide.addClass("is-selected").attr("aria-selected", "true");
        
        console.log("click triggered done ==============================");
    });
  });

  $(document).on("click", ".columns_container_right .column_view", function(){
    var $carousel = $('.thumbnail-slide').flickity();
    $carousel.flickity('destroy');
    $carousel.flickity();
  });

  var tabContentId = $(".tab_slider_section").find(".tabcontent.active").attr("id");
  $(".tab_slider_section .tab .tablinks").click(function(){
    var tabContentId = $(this).parents(".tab_slider_section").find(".tabcontent.active").attr("id");
    var slider = $(this).parents(".tab_slider_section").find('#'+ tabContentId +' .collection-item__slider');
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
    collectionItemSliderInitialize(tabContentId);
  });
  collectionItemSliderInitialize(tabContentId);
  
  $('.all_reviews').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots:true,
    arrows:false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 544,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1
        }
      }
    ]
  }); 

  if (window.matchMedia('(max-width: 991px)').matches) {
    $('.js-featured-promotions').slick({
      infinite: false,
      slidesToShow: 2.5,
      slidesToScroll: 1,
      dots:true,
      arrows:false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 544,
          settings: {
            slidesToShow: 1.3,
            slidesToScroll: 1
          }
        }
      ]
    }); 
  }


  
  // ATC Call for button click trigger on product page js start

  $(".img_with_txt .button-grid-container .global-button").click(function(){
    console.log("click");
    $(".purchase-details__buttons .add_to_cart").click("trigger");
    console.log("clicked");
  });
  
  // ATC Call for button click trigger on product page js end
});

document.addEventListener('DOMContentLoaded', function() {
  var inputs = document.querySelectorAll('.product-monogram-upsel fieldset input[type="text"]');
  inputs.forEach(function(input) {
    input.addEventListener('input', function() {
      if (this.value.length > 4) {
        this.value = this.value.slice(0, 4);
      }
    });
  });
});

function collectionItemSliderInitialize(tabContentId) {
  $('#'+ tabContentId +' .collection-item__slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 3,
    prevArrow:'<div class="slick-arrow slick-prev"><svg fill="#000000" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve"><path id="XMLID_92_" d="M111.213,165.004L250.607,25.607c5.858-5.858,5.858-15.355,0-21.213c-5.858-5.858-15.355-5.858-21.213,0.001l-150,150.004C76.58,157.211,75,161.026,75,165.004c0,3.979,1.581,7.794,4.394,10.607l150,149.996C232.322,328.536,236.161,330,240,330s7.678-1.464,10.607-4.394c5.858-5.858,5.858-15.355,0-21.213L111.213,165.004z"/></svg></div>',
    nextArrow:'<div class="slick-arrow slick-next"><svg fill="#000000" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve"><path id="XMLID_92_" d="M111.213,165.004L250.607,25.607c5.858-5.858,5.858-15.355,0-21.213c-5.858-5.858-15.355-5.858-21.213,0.001l-150,150.004C76.58,157.211,75,161.026,75,165.004c0,3.979,1.581,7.794,4.394,10.607l150,149.996C232.322,328.536,236.161,330,240,330s7.678-1.464,10.607-4.394c5.858-5.858,5.858-15.355,0-21.213L111.213,165.004z"/></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', function () {
  var $gallery = $('.product-gallery__grid');
  var $thumbNav = $('.product_gallery_nav');

  // Custom SVG arrows for main slider
  var prevArrowHTML = '<button type="button" class="slick-prev custom-arrow" aria-label="Previous slide">' +
    '<svg width="34" height="34" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path fill="#333" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>' +
    '</svg>' +
  '</button>';

  var nextArrowHTML = '<button type="button" class="slick-next custom-arrow" aria-label="Next slide">' +
    '<svg width="34" height="34" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path fill="#333" d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/>' +
    '</svg>' +
  '</button>';

  function initSlick() {
    if (window.innerWidth <= 767 && !$gallery.hasClass('slick-initialized')) {
      // Main gallery
      $gallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        speed: 400,
        swipeToSlide: true,
        lazyLoad: 'ondemand',
        asNavFor: '.product_gallery_nav',
        prevArrow: prevArrowHTML,
        nextArrow: nextArrowHTML,
      });

      // Thumbnail nav
      $thumbNav.slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        asNavFor: '.product-gallery__grid',
        focusOnSelect: true,
        arrows: false,
        dots: false,
        infinite: true,
        variableWidth: true,
      });

      // Pause/play videos properly
      $gallery.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $slides = $(slick.$slides);
        $slides.each(function (i, slide) {
          var $videos = $(slide).find('iframe, video');
          $videos.each(function () {
            if (i === nextSlide) {
              if ($(this).data('src') && !this.src) this.src = $(this).data('src');
              if (this.tagName === 'VIDEO') this.play().catch(() => {});
            } else {
              if (this.tagName === 'VIDEO') this.pause();
              if (this.tagName === 'IFRAME') this.src = '';
            }
          });
        });
      });
    }
  }

  function destroySlick() {
    if (window.innerWidth > 767) {
      if ($gallery.hasClass('slick-initialized')) {
        $gallery.slick('unslick');
      }
      if ($thumbNav.hasClass('slick-initialized')) {
        $thumbNav.slick('unslick');
      }
    }
  }

  initSlick();
  $(window).on('resize', function () {
    initSlick();
    destroySlick();
  });
});
$(document).ready(function() {
  $('#show-more-button').click(function() {
    // Show the hidden gallery items
    $('.gallery-cell.hidden').slideDown().removeClass('hidden');
    
    // Hide the show more button after all items are visible
    $(this).hide();
  });

  // if (window.location.href.indexOf("/products/") > -1) {
  //   $(".image-with_text-slide .description").each(function() {
  //     var TextCharCount = $(this).find(".metafield-rich_text_field p:first-child").text().length;
  //     if(TextCharCount > 200){
  //        $(this).find(".read-more").css('display', 'block'); 
  //     }
  //   });
    
  //   $(".read-more").click(function(){
  //       var TextValue = $(this).text();
  //       if(TextValue == "Read More") {
  //          $(this).text("Read Less");
  //          $(this).siblings(".metafield-rich_text_field").css({
  //              'overflow': 'visible',
  //              'max-height': '100%'
  //          }); 
  //       } else {
  //          $(this).text("Read More");
  //          $(this).siblings(".metafield-rich_text_field").css({
  //              'overflow': 'hidden'
  //          }); 
  //       }
  //   });
  // }

  $('.read-more').click(function(){
    $(this).parents('.image-with-text-container').toggleClass('active');
  });

  // JOIN THE WAITLIST BUTTON TRIGGER CLILCK JS START
  // $(".sticky--sold-out__btn").click(function(){
  //   alert('sdfdfdf');
  //   if ($(".klaviyo-bis-trigger").is(':visible')) {
  //     $(".klaviyo-bis-trigger").trigger('click');
  //     alert('dfnjdfd');
  //   } else {
  //     console.log("Button is not visible or available.");
  //     alert('sdfsdff');
  //   }
  // });
  // JOIN THE WAITLIST BUTTON TRIGGER CLILCK JS END
// JavaScript to initialize Slick Slider
 // Function to initialize or reinitialize the Slick slider
  function initializeSlickSlider() {
    var $tabslider = $('.collection-item__slider');
    // Destroy the existing Slick slider if it's already initialized
    if ($tabslider.hasClass('slick-initialized')) {
      $tabslider.slick('unslick');
    }
    // Reinitialize Slick slider
    $tabslider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '60px',
            infinite: true,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '60px',
            infinite: true,
            arrows: false
          }
        }
      ]
    });
  }
  
  // Initialize Slick slider on page load
  $(document).ready(function() {
    initializeSlickSlider();
  });
  
  // Initialize or reinitialize Slick slider when a tab is clicked
  $('.tablinks').on('click', function() {
    initializeSlickSlider();
  });

  $('.layout-switch').click(function(){
    $(this).addClass('layout-switch--active');
    $(this).siblings().removeClass('layout-switch--active');
    $('.product-list').toggleClass('switch-oneItem');
  })

  $('.filter-close').click(function(){
    $('.sidebar-filter-action').removeClass('active_sidebar');
    $('.sidebar').removeClass('active11');
    $('body').removeClass('filter_sidebar_open');
  });

  $('.faceted-filter-group-summary').click(function(){
    $(this).toggleClass('filter-menu-hide').siblings('.faceted-filter-group-display').slideToggle();
  })

    function offerSlider(){
      $('.offer_slide_inner').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
      dots:true
    });
  }
  
  $('.mobile-cat-tab').click(function(){
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    var dataTab = $(this).data('tab');
    $('.mobile-tab-content').find('#'+ dataTab).addClass('active');
    $('.mobile-tab-content').find('#'+ dataTab).siblings().removeClass('active');
     $('.offer_slide_inner').slick('unslick'); 
    offerSlider();
  });

  $('.mobile-drawer-level-1-inner.has_submenu').click(function(){
    $(this).siblings('.mobile-drawer-level-2').slideToggle();
    $(this).parents('.mobile-drawer-level-1').toggleClass('active');
    $(this).parents('.mobile-drawer-level-1').siblings().find('.mobile-drawer-level-2').slideUp();
    $(this).parents('.mobile-drawer-level-1').siblings().find('.mobile-drawer-level-1-inner.has_submenu').removeClass('active');
  });  

  $('.mobile_nav').click(function(){
    offerSlider();
  });

  $('.mobile_custom_menu_title').click(function(){
    $(this).siblings().slideToggle().parents('.mobile_custom_menu_item').toggleClass('active');
  });

   // ================ START: Tetsimonial section v2 slider =====================
  $('.custom-testimonial-inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true
  });
  // ================ END: Tetsimonial section v2 slider =====================


  
  // split description text
  $('.split_btn_more').click(function() {
    $('.full_text').show();
    $('.split_text').hide();
  });
  $('.split_btn_less').click(function() {
    $('.split_text').show();
    $('.full_text').hide();
  });
  
});